"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureMobX = void 0;
const mobx_1 = require("mobx");
const configureMobX = () => {
    (0, mobx_1.configure)({ enforceActions: 'observed' });
};
exports.configureMobX = configureMobX;
